import React from 'react';
import './AdminLMSMain.css';

const AdminLMSMain = () => {
  console.log('[AdminLMSMain] Render');
  return (
    <div className="academy-page-shell admin-lms-main">
      <div className="lms-main-welcome">
        <h1>Welcome, Admin!</h1>
        <p className="lms-main-desc">Manage users, courses, and reports with ease. Use the sidebar to access your admin tools.</p>
        <div className="lms-main-graphic admin"></div>
      </div>
    </div>
  );
};

export default AdminLMSMain;
